import React from "react";

const QuestionField = ({ question, value, error, onChange }) => {
  const { text, type, options = [], questionId } = question;

  const handleChange = (e) => {
    const val = type === "radio" ? e.target.value : e.target.value.trim();
    onChange(val);
  };

  return (
    <div className="mb-4" id={questionId}>
      <label
        className="block text-[13px] font-normal mb-2"
        htmlFor={questionId}
      >
        {text}
      </label>
      {type === "text" || type === "number" ? (
        <input
          type={type}
          id={questionId}
          value={value}
          onChange={handleChange}
          placeholder="Please Enter"
          className={`w-full px-4 outline-none focus:ring-0 py-2 bg-[#0087A31A] border rounded-xl ${
            error ? "border-red-500" : ""
          }`}
        />
      ) : type === "radio" ? (
        <div>
          {options.map((option) => (
            <label key={option.key} className="inline-flex items-center mr-4">
              <input
                type="radio"
                name={questionId}
                value={option.value}
                checked={value === option.value}
                onChange={handleChange}
                className="form-radio"
              />
              <span className="ml-2">{option.value}</span>
            </label>
          ))}
        </div>
      ) : type === "select" ? (
        <select
          id={questionId}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          className={`w-full px-4 py-2 border rounded ${
            error ? "border-red-500" : ""
          }`}
        >
          <option value="" disabled>
            Select Option
          </option>
          {options.map((option) => (
            <option key={option.key} value={option.value}>
              {option.value}
            </option>
          ))}
        </select>
      ) : null}
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default QuestionField;
